import styled from "styled-components";

import { theme } from "@/components/bild/theme";
import { colors } from "@/styles/Variants";

const color = colors.bild;
const { fontFamily, breakpoint } = theme;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
  margin-bottom: 12px;
  font-weight: 700;
  font-family: ${fontFamily.gothamCondensed};
  font-size: 40px;
  color: ${color.vader500};

  @media ${breakpoint.medium} {
    font-size: 36px;
  }
  @media ${breakpoint.small} {
    font-size: 32px;
  }
`;

export const Subheader = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  font-weight: 400;
  font-family: ${fontFamily.gothamCondensed};
  font-size: 24px;
  color: ${color.vader500};

  @media ${breakpoint.medium} {
    font-size: 20px;
  }
  @media ${breakpoint.small} {
    font-size: 18px;
  }
`;

export const Checkmark = styled.div`
  position: relative;
  margin: auto;
  width: 96px;
  height: 96px;

  &:after {
    content: "";
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%) rotate(45deg);
    width: 24px;
    height: 40px;
    border: solid ${color.chewie500};
    border-width: 0 6px 6px 0;
    border-bottom-right-radius: 1px;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
`;

export const Wrapper = styled.div`
  padding: 44px;
`;
